<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Aprobación de Matriculación </h3>
            <h6 align="right">Costo Matriculacion {{ c_ship_approved_pending.importe_tramite | round }}</h6>
            <h6 align="right"> {{ c_cost_enrollment }}</h6>
            <!-- <div class="form-row">
                <button class="btn btn-outline-success col-6 col-md-1 offset-md-11" @click="fEditForm" v-if="d_disabled_admin">
                        <font-awesome-icon icon="edit" size="lg" />
                </button>
                <button class="btn btn-outline-info col-6 col-md-1 offset-md-11" @click="fEditForm" v-else>
                        <font-awesome-icon icon="save" size="lg" />
                </button>
            </div> -->
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link disabled" :class="[is_active_step_one ? 'active':'']" id="nav-init-enrollment" data-toggle="tab" href="#nav-init-enrollment" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_two ? 'active':'']" id="nav-second-enrollment" data-toggle="tab" href="#nav-second-enrollment" role="tab" aria-controls="nav-detail" aria-selected="false">2. Detalle</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_tree ? 'active':'']" id="nav-tirdh-enrollment" data-toggle="tab" href="#nav-tirdh-enrollment" role="tab" aria-controls="nav-property" aria-selected="false">3. Motor</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_fourth ? 'active':'']" id="nav-fourth-enrollment" data-toggle="tab" href="#nav-fourth-enrollment" role="tab" aria-controls="nav-motor" aria-selected="false">4. Propietario</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                
                <div class="tab-pane fade" :class="[is_active_step_one ? 'show active':'']" id="nav-init-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcacion</label>                    
                            <input type="text" class="form-control" v-model="c_ship_approved_pending.nombre" id="enrollment_boat" placeholder="Nombre Embarcacion" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                        
                        <div class="form-group col col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera de la Embarcacion</label>
                            <input type="text" class="form-control" v-model="flag" name="flag" disabled placeholder="BOLIVIA" autocomplete="off" >
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="material_head" class="badge badge-primary">Material del casco</label>
                            <select class="form-control" name="material_head" v-model="c_ship_approved_pending.material_construccion" :disabled="d_disabled_admin">
                                <option v-for="head in material_heads" :value="head.id" :key="head.id">{{ head.detail }}</option>
                            </select>
                        </div>
                        
                        <div class="form-group col col-md-6">
                            <label for="type_navigate" class="badge badge-primary">Tipo Navegacion</label>
                            <select class="form-control" name="type_navigate" v-model="c_ship_approved_pending.destino_navegacion" :disabled="d_disabled_admin">
                                <option v-for="navigate in type_navigates" :value="navigate.id" :key="navigate.id">{{ navigate.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo de nave</label>
                            <select class="form-control" name="type_ship" v-model="c_ship_approved_pending.destino_embarcacion" :disabled="d_disabled_admin">
                                <option v-for="ship in type_ships" :value="ship.id" :key="ship.id">{{ ship.detail }}</option>
                            </select>
                        </div>
                        <div class="form-group col col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo de Propulsion</label>
                            <select class="form-control" name="type_ship" v-model="c_ship_approved_pending.propulsion" :disabled="d_disabled_admin">
                                <option v-for="propulsion in d_type_propulsions" :value="propulsion.id" :key="propulsion.id">{{ propulsion.detail }}</option>
                            </select>
                        </div>                        
                    </div>      
                    

                    <button class="btn btn-outline-warning col col-md-4 offset-md-4" @click="fNext"><font-awesome-icon icon="chevron-circle-right" size="lg" /></button>
                </div>
                <!-- end first tab traffic -->

                <div class="tab-pane fade" :class="[is_active_step_two ? 'show active':'']" id="nav-second-enrollment" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="number" name="trb" class="form-control" placeholder="TRB" v-model="c_ship_approved_pending.trb" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="trn" class="badge badge-primary">TRN</label>
                            <input type="number" name="trn" class="form-control" placeholder="TRN" v-model="c_ship_approved_pending.trn" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md-3">
                            <label for="eslora" class="badge badge-primary">Eslora</label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.eslora" name="eslora" placeholder="Eslora" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="manga" class="badge badge-primary">Manga</label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.manga" name="manga" placeholder="Manga" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="puntal" class="badge badge-primary">Puntal</label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.puntal" name="puntal" placeholder="Puntal" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="eslora" class="badge badge-primary">Calado</label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.calado" name="calado" placeholder="Calado" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md-3">
                            <label for="year_construction" class="badge badge-primary">Año de construccion</label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.anio_construccion" name="flag" placeholder="Año" autocomplete="off" :disabled="d_disabled_admin">
                        </div>

                        <div class="form-group col col-md-6">
                            <label for="site_contruction" class="badge badge-primary">Lugar construccion</label>
                            <input type="text" class="form-control" v-model="c_ship_approved_pending.lugar_construccion" name="call_sign" placeholder="Lugar de construccion" autocomplete="off" :disabled="d_disabled_admin">
                        </div>

                        <div class="form-group col col-md-3">
                            <label for="cost_construction" class="badge badge-primary">Costo de construccion</label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.costo_construccion" name="cost_construction" placeholder="Costo" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                    </div>  

                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="type_ship" class="badge badge-primary">Destino Actividad</label>
                            <select class="form-control" name="type_ship" v-model="c_ship_approved_pending.parameters_traffic" @change="callService" :disabled="d_disabled_admin">
                                <option v-for="activity in d_types_activity_ship" :value="activity.id" :key="activity.id">{{ activity.detail }}</option>
                            </select>
                        </div>

                        <transition name="fade" mode="out-in">
                        <div class="form-group col col-md-6">
                            <label for="type_service" class="badge badge-primary">Tipo de Servicio</label>
                            <select class="form-control" name="type_service" v-model="c_ship_approved_pending.destino_embarcacion" :disabled="d_disabled_admin">
                                <option v-for="service in type_services" :value="service.id" :key="service.id">{{ service.detail }}</option>
                            </select>
                        </div>
                        </transition>

                    </div>

                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end second tab -->

                <div class="tab-pane fade" :class="[is_active_step_tree ? 'show active':'']" id="nav-tirdh-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <transition name="fade" mode="out-in">
                        <div class="form-row" v-if="cQuestionEngine">
                            <span class="col-12">¿Desea agregar caracteristicas de motor a la nave? <br>Caso contrario omita este mensaje y pase al siguiente paso  </span>                        
                            <button class="btn btn-outline-success btn-sm col-6 col-md-2 offset-md-4" value="si" @click="mAddEngine">AGREGAR</button>                            
                        </div>
                        
                    </transition>

                    <transition name="fade" mode="out-in">
                    <div v-if="engine_exists">
                        <div class="form-row">
                            <button type="button" class="btn btn-outline-danger col-12 col-md-1 offset-md-10" @click="mAddEngine" value="no"><font-awesome-icon icon="window-close" /></button>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="brand_engine" class="badge badge-primary">Marca Motor</label>
                                <input type="text" class="form-control" v-model="engine.marca" name="flag" placeholder="Marca Motor" :disabled="d_disabled_admin" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="model_engine" class="badge badge-primary">Modelo Motor</label>
                                <input type="text" class="form-control" v-model="engine.modelo" name="model_engine" placeholder="Modelo Motor" :disabled="d_disabled_admin" autocomplete="off">
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="rpm_engine" class="badge badge-primary">HP por RPM</label>
                                <input type="number" :disabled="d_disabled_admin" class="form-control" v-model="engine.hp_rpm" name="flag" placeholder="Hp por RPM" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="serie_engine" class="badge badge-primary">Serie</label>
                                <input type="text" class="form-control" :disabled="d_disabled_admin" v-model="engine.serie" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>                    
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="combustible_construction" class="badge badge-primary">Combustible</label>
                                <select class="form-control" name="combustible_construction" v-model="engine.combustible" :disabled="d_disabled_admin">
                                    <option v-for="gas in type_gasolines" :value="gas.id" :key="gas.id">{{ gas.detail }}</option>
                                </select>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_autonomia" class="badge badge-primary">Autonomia</label>
                                <input type="text" class="form-control" v-model="engine.autonomia" name="model_engine" placeholder="Autonomia Motor" autocomplete="off" :disabled="d_disabled_admin">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_velocity" class="badge badge-primary">Velocidad Maxima</label>
                                <input type="number" class="form-control" v-model="engine.velocidad_max" name="engine_velocity" placeholder="Velocidad Maxima" :disabled="d_disabled_admin" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    </transition>
                    <br>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end trirdh tab -->
                <div class="tab-pane fade" :class="[is_active_step_fourth ? 'show active':'']" id="nav-fourth-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    <br>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="type_identification" class="badge badge-primary">Tipo Identificacion</label>
                            <select class="form-control" name="type_ship" v-model="c_ship_approved_pending.tipo_identificacion" :disabled="d_disabled_admin" @change="mChangeOwnerIdentification">
                                <option v-for="identification in types_identification" :value="identification.id" :key="identification.id">{{ identification.detail }}</option>
                            </select>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                            <input type="text" class="form-control" v-model="c_ship_approved_pending.dato_identificacion" name="number_identification" placeholder="Numero de Identificacion" :disabled="d_disabled_admin" autocomplete="off">
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="site_expedition" class="badge badge-primary">Lugar Emision </label>
                            <select class="form-control" name="site_expedition" v-model="c_ship_approved_pending.expedido" :disabled="d_disabled_admin">
                                <option v-for="city in citys" :value="city.id" :key="city.id">{{ city.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="owner_name" class="badge badge-primary">Nombre Propietario</label>
                            <input type="text" class="form-control" v-model="c_ship_approved_pending.nombre_propietario" name="owner_name" placeholder="Nombre Propietario" autocomplete="off" :disabled="d_disabled_admin">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_direction" class="badge badge-primary">Direccion </label>
                            <input type="text" class="form-control" v-model="c_ship_approved_pending.domicilio" name="owner_direction" placeholder="Direccion" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                    </div>

                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_celular" class="badge badge-primary">Celular </label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.celular" name="owner_celular" placeholder="Celular" autocomplete="off" :disabled="d_disabled_admin">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="phone_static" class="badge badge-primary">Telefono Fijo </label>
                            <input type="number" class="form-control" v-model="c_ship_approved_pending.telefono_fijo" name="phone_static" placeholder="Telefono Fijo" autocomplete="off" :disabled="d_disabled_admin">
                        </div>
                    </div>
                    
                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_partner" class="badge badge-primary">Representante Legal </label>
                            <input type="text" class="form-control" v-model="c_ship_approved_pending.representante_legal" name="owner_partner" placeholder="Representante Legal" autocomplete="off" :disabled="d_disabled_admin">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_nationality" class="badge badge-primary">Nacionalidad </label>
                            <select class="form-control" name="site_expedition" v-model="c_ship_approved_pending.nacionalidad" :disabled="d_disabled_admin">
                                <option v-for="country in countrys" :value="country.id" :key="country.id">{{ country.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="enrollment_manually" class="badge badge-danger">Asignacion matricula</label>
                            <input type="text" class="form-control" v-model="old_new_enrollment" autocomplete="off">
                        </div>
                    </div>

                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button v-if="d_btn_status_enrollment" class="btn btn-outline-primary col col-md-4" @click="mValidateSend">Matricular <font-awesome-icon icon="save" size="lg" /></button>
                    <button v-else class="btn btn-outline-dark col col-md-4" @click="mSendHome">Inicio <font-awesome-icon icon="home" size="lg" /></button>    
                </div>
            </div>
            
        </div>
        <modal-loading :id-modal="modal_progress" :title="d_title" :status-send="send_dispatch" ></modal-loading>
        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
        <!-- <div class="row">
            <pre class="col-12 col-md-6">{{ engine }}</pre>
            <pre class="col-12 col-md-6">{{ c_ship_approved_pending }}</pre>
        </div> -->
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';


export default {
    name:'enrollment',
    data(){
        return{
            searchOwner:'Busqueda Nombre',
            d_disabled_admin:true,
            is_active_step_one:true,
            is_active_step_two:false,
            is_active_step_tree:false,
            is_active_step_fourth:false,
            flag:'BOLIVIA',
            material_heads:[],
            type_ships:[],
            type_services:[],
            type_navigates:[],
            d_type_propulsions:[],
            d_types_activity_ship:[],
            type_gasolines:[],
            engine:{
                id_motor:null,
                numero_motor:null,
                hp_rpm:null,
                serie:null,
                modelo:null,
                marca:null,
                combustible:null,
                autonomia:null,
                velocidad_max:null,
                status:false
            },
            engine_aux:{
                id_motor:null,
                numero_motor:null,
                hp_rpm:null,
                serie:null,
                modelo:null,
                marca:null,
                combustible:null,
                autonomia:null,
                velocidad_max:null,
                status:true
            },
            engine_exists:false,
            types_identification:[],
            citys:[],
            countrys:[],
            modal_progress:'sendAuthorizationEnrollment',
            modal_report:'requestAuthorizationEnrollment',
            modal_rep_title:'Matriculacion',
            modal_rep_content:'',
            url_report:'pdfEnrollmentShip',
            send_dispatch:true,
            id_reporte:0,
            d_question_engine:true,
            d_title:'Actualizando',
            d_btn_status_enrollment:true,
            old_new_enrollment:null
            // d_disabled_partner:false      
        }
    },
    mounted(){
        this.mProgressModal();
        this.callHeads(),
        this.callTypeNavigate(),
        this.callTypeShip(),
        this.mCallPropulsion(),
        this.mCallActivitiesShip(),
        this.mCallGasolines(),
        this.mCallIdentifications(),
        this.mCallCitys(),
        this.mCallCountrys(),
        this.mCallEngine();
        setTimeout(()=>{
            this.mCloseProgressModal();
        }, 3000)
        
    },
    methods:{
        mCallEngine(){
            // #FIXME: aqui verificamos si la nave tiene motor
            // axios.get('getEngineBoatPendingEnrollment/'+this.c_ship_approved_pending.id_maestro+'?api_token='+Vue.auth.getToken())
            // axios.get(`getEngineBoatPendingEnrollment/${this.c_ship_approved_pending.id_maestro}`)
            axios.get(`getEngineBoatPendingEnrollment/${this.c_ship_approved_pending.id_maestro}?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                if(res.data.length > 0){
                    this.d_question_engine=false;
                    this.engine.id_motor=res.data[0].id_motor;                        
                    this.engine.numero_motor=res.data[0].numero_motor;
                    this.engine.hp_rpm=res.data[0].hp_rpm;
                    this.engine.serie=res.data[0].serie;
                    this.engine.modelo=res.data[0].modelo;
                    this.engine.marca=res.data[0].marca;
                    this.engine.combustible=res.data[0].combustible;
                    this.engine.autonomia=res.data[0].autonomia;
                    this.engine.velocidad_max=res.data[0].velocidad_max;
                    this.engine.status=true;
                    
                    this.engine_aux.id_motor=res.data[0].id_motor;                        
                    this.engine_aux.numero_motor=res.data[0].numero_motor;
                    this.engine_aux.hp_rpm=res.data[0].hp_rpm;
                    this.engine_aux.serie=res.data[0].serie;
                    this.engine_aux.modelo=res.data[0].modelo;
                    this.engine_aux.marca=res.data[0].marca;
                    this.engine_aux.combustible=res.data[0].combustible;
                    this.engine_aux.autonomia=res.data[0].autonomia;
                    this.engine_aux.velocidad_max=res.data[0].velocidad_max;
                    this.engine_aux.status=true;

                    this.engine_exists=true;                  
                    
                }else{
                    this.d_question_engine=true;
                    this.engine_exists=false;
                }
            })    
        },
        mAddEngine(event){
            switch(event.target.value){
                case 'no':
                    this.d_question_engine=true;
                    this.engine_exists=false;
                    this.engine.status=false;
                break;

                case 'si':
                    this.d_question_engine=false;
                    this.engine_exists=true;
                    this.engine.status=true;
                break;
            }
        },
        mProgressModal(){
            $('#'+this.modal_progress).modal('show');
        },
        mCloseProgressModal(){

            $('#'+this.modal_progress).modal('hide');
        },
        mModalReportShow(){
            $('#'+this.modal_report).modal('show');
        },
        mCallCountrys(){
            // axios.get(`globals/country`)
            axios.get(`globals/country?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.countrys=res.data
            })
        },
        mCallCitys(){
            // axios.get(`globals/citys`)
            axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.citys=res.data
            })
        },
        mCallIdentifications(){
            // axios.get(`globals/ident`)
            axios.get(`globals/ident?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.types_identification=res.data
            })
        },
        mCallGasolines(){
            // axios.get(`globals/gasoline`)
            axios.get(`globals/gasoline?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_gasolines=res.data
            })
        },
        mCallPropulsion(){
            // axios.get(`submenus/4`)
            axios.get(`submenus/4?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.d_type_propulsions=res.data
            })
        },
        callHeads(){
            // axios.get(`globals/materialhead`)
            axios.get(`globals/materialhead?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.material_heads=res.data
            })
        },
        callTypeShip(){
            // axios.get(`globals/ships`)
            axios.get(`globals/ships?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                
                this.type_ships=res.data
            })
        },
        mCallActivitiesShip(){
            // axios.get(`ships/servicionave`)
            axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                this.d_types_activity_ship=res.data;
                this.callService()
            })
        },
        callService(){
            this.type_services=[];
            axios.get(`submenus/${this.c_ship_approved_pending.parameters_traffic}?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_services=res.data
            })
        },
        callTypeNavigate(){
            // axios.get(`globals/navigates`)
            axios.get(`globals/navigates?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_navigates=res.data
            })
        },
        mSendHome(){
            this.$store.dispatch('sShipEnrollmentP/deleteShipPendingEnrollment', true);
            this.$store.dispatch('sAuxShipEnrollmentP/deleteAuxShipPendingEnrollment', true);
            this.$router.push('approved-enrollment');
        },
        mSendEnrollment(){
            
            //# FIXME: verificar el rechazo si es que la serie del motor se encuentra registrado y se intenta registrar el mismo, se debe rechazar e indicar que la serie del motor ya esta registrada 
            let message = {
                title: `Aprobar Matriculacion de Nave`,
                body: `¿Desea aprobar la asignacion de Matricula para la Nave o Artefacto Naval, <b>${this.c_ship_approved_pending.nombre}</b> ?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then((msg) =>{
                if(msg){
                    this.mProgressModal();
                    this.d_title='Matriculando';
                    let parametros={
                        dtsShipEnrollment:JSON.stringify(this.c_ship_approved_pending),
                        dtsEngineShip:JSON.stringify(this.engine),
                        old_new_enrollment:this.old_new_enrollment
                    }
                    
                    // axios.post(`assignCodeEnrollment`,
                    axios.post(`assignCodeEnrollment?api_token=${Vue.auth.getToken()}`,
                                        qs.stringify(parametros))
                            .then(res=>{
                                if(res.data.status){                
                                    setTimeout(()=>{
                                        this.mCloseProgressModal();
                                        this.modal_rep_content=res.data.respuesta;
                                        this.id_reporte=this.c_ship_approved_pending.id_maestro;
                                        this.mModalReportShow();
                                        this.d_btn_status_enrollment=false;
                                        // FIXME: aqui anular el boton de matriculacion solamente

                                    }, 2000);
                                    
                                }else{
                                    setTimeout(()=>{
                                        this.mCloseProgressModal();
                                        toastr.error(res.data.respuesta+' Contacte al administrador','Error');
                                        // FIXME: indicar que se debe contactar al administrador
                                    }, 2000);
                                }             
                            }).catch(error => {
                                console.log(error);
                                setTimeout(()=>{
                                    this.mCloseProgressModal();
                                    toastr.error('Verifique la serie o el documento del propietario','Error');
                                }, 3000);
                                // console.log(error)
                            })
                }else{
                    console.log(`no se ha autorizado la matriculacion`);
                }
            })
        },
        mValidateSend(){
            let aux_validate=true;
            // FIXME: validar los campos antes de enviar por ahora solo se envia sin validaciones
            /* if(!this.name_ship && aux_validate){
                toastr.error('Verifique el nombre de la nave','Nombre');
                aux_validate=!aux_validate;
            }
            if(!this.material_head && aux_validate){
                toastr.error('Verifique el material del casco de la nave','Material Casco');
                aux_validate=!aux_validate;
            }
            if(!this.type_navigate && aux_validate){
                toastr.error('Verifique el tipo de Navegacion','Tipo Navegacion');
                aux_validate=!aux_validate;
            }
            if(!this.type_ship && aux_validate){
                toastr.error('Verifique el tipo de Nave','Tipo Nave');
                aux_validate=!aux_validate;
            }
            if(!this.d_type_propulsion.id && aux_validate){
                toastr.error('Verifique el tipo de Propulsion','Propulsion');
                aux_validate=!aux_validate;
            }
            if(!this.trb && aux_validate){
                toastr.error('Verifique el TRB','TRB');
                aux_validate=!aux_validate;
            }
            if(!this.type_service.id && aux_validate){
                toastr.error('Verifique el tipo de servicio de la Nave','Tipo Servicio');
                aux_validate=!aux_validate;
            }
            if(!this.owner.nationality && aux_validate){                
                toastr.error('Indique la Nacionalidad del Titular','Nacionalidad');
                aux_validate=!aux_validate;
            }
            if(!this.owner.type_identification && aux_validate){
                toastr.error('seleccione un tipo de identificacion','Identificacion');
                aux_validate=!aux_validate;
            }
            if(!this.owner.number_identification && aux_validate){
                toastr.error('Indique un numero de identificacion','Numero Indenficacion');
                aux_validate=!aux_validate;
            }
            if(!this.owner.site_expedition && aux_validate){
                toastr.error('Seleccione el departamento de Emision','Emision de Cedula');
                aux_validate=!aux_validate;
            }
            if(!this.owner.name && aux_validate){
                toastr.error('Indique el Nombre del Propietario','Nombre Propietario');
                aux_validate=!aux_validate;
            } */

            if(this.old_new_enrollment === null ){
                toastr.error('Indique la matricula a asignar a la embarcacion','Matricula');
                aux_validate=false;
            }

            if(aux_validate){
                this.mSendEnrollment();
            }
            
        },
        mResetForm(){
            // #FIXME: AQUI HAY QUE REDIRECCIONAR A LA PANTALLA DE BUSQUEDA PREVIAMENTE AL REPORTE YA EMITIDO Y CERRADO LA PANTALLA
        },
        mChangeOwnerIdentification(){
            
            switch(this.owner.type_identification){
                case 17:
                // cedula identidad
                    this.d_disabled_partner=true;
                break;

                case 18:
                // nit
                    this.d_disabled_partner=false;
                break;
            }
        },
        fNext(){
            switch(true){
                case this.is_active_step_one:
                    this.is_active_step_one=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_tree=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_fourth=true;
                break;
            }
        },
        fBack(){            
            switch(true){
                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_one=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_fourth:
                    this.is_active_step_fourth=false;
                    this.is_active_step_tree=true;
                break;
            }
        },
        fEditForm(){
            
            let dtsAux=0;
            let engineDtsAux=0;
            let message='Se actualizo de manera exitosa';
            this.d_disabled_admin=!this.d_disabled_admin;
            if(this.d_disabled_admin===true){                
                
                // actualiza datos de la nave y del propietario
                dtsAux=this.mCompareArray(this.c_ship_approved_pending, this.c_aux_ship_approved_pending);
                
                engineDtsAux=this.mCompareArray(this.engine, this.engine_aux);
                
                this.mProgressModal();
                
                if(dtsAux>0 || engineDtsAux>0){
                    // let shipPending=[this.c_ship_approved_pending];
                    let shipPending={
                        dtsBoatPending:JSON.stringify(this.c_ship_approved_pending),
                        dtsEnginePending:JSON.stringify(this.engine)
                    }
                    // aqui deberia ser una peticion put
                    // axios.post(`updateShipPending`, qs.stringify(shipPending) )
                    axios.post(`updateShipPending?api_token=${Vue.auth.getToken()}`, qs.stringify(shipPending) )
                    .then(res=>{
                        if(res.data.estado){
                            this.$store.dispatch('sShipEnrollmentP/addShipPendingEnrollment', this.c_ship_approved_pending);
                            this.$store.dispatch('sAuxShipEnrollmentP/addAuxShipPendingEnrollment', this.c_ship_approved_pending);
                            message=res.data.respuesta;
                        }else{
                            message=res.data.respuesta;
                        }
                    }).catch(error=>{
                        console.log(error)
                    })
                }

                setTimeout(()=>{
                            this.mCloseProgressModal();
                            toastr.success(message, 'Actualizacion');
                }, 3000)
                
            }
            // this.d_disabled_admin=!this.d_disabled_admin;            
        },
        mCompareArray(Array1, ArrayAux){
            let auxUpdate=0;
            for (var key in Array1){
                for( var key_aux in ArrayAux){
                    if(key === key_aux){
                        if( !(Array1[key]===ArrayAux[key_aux]) ){
                            auxUpdate++;
                        }
                    }
                }
            }
            return auxUpdate;
        },
        mSearchFactor(id, ArrayVals){
            var factor=0;
            ArrayVals.forEach(function(element, index) {
                if(element.id == id){
                    factor = element.factor;
                }
            });
            return factor;
        }
    },
    computed:{
        c_ship_approved_pending(){
            return this.$store.getters['sShipEnrollmentP/getEnrollmentPendingShip'];
        },
        c_aux_ship_approved_pending(){
            return this.$store.getters['sAuxShipEnrollmentP/getAuxEnrollmentPendingShip'];
        },
        c_ufv(){
            return this.$store.getters.getUFV;
        },
        c_type_propulsion:function(){
            return this.d_type_propulsion.factor;
        },
        c_trb:function(){
            return this.trb;
        },
        c_service:function(){
            return this.type_service.factor;
        },
        c_cost_enrollment(){
            // #TODO: aqui se debe buscar en los registros que ya se tiene de propulsion y actividad de la nave los valores obtenidos deberan ser llevados a la base de datos
            let propulsion=this.mSearchFactor(this.c_ship_approved_pending.propulsion, this.d_type_propulsions);
            let servicio = this.mSearchFactor(this.c_ship_approved_pending.destino_embarcacion, this.type_services);
            
            // let cost_enrollment = 3*this.c_ufv*(5+this.c_type_propulsion*this.c_service*this.trb*this.c_cal_cut);
            // let cost_enrollment = 3*this.c_type_propulsion;
            let cost_enrollment = 3*this.c_ufv*(5+propulsion*servicio*this.c_ship_approved_pending.trb*this.c_cal_cut);

            let aux_number=cost_enrollment.toFixed(2);
            
            let number_enter=Math.trunc(aux_number);
            let number_decimal=Number((aux_number-number_enter).toFixed(2));

            

            if(number_decimal===0.50){
                cost_enrollment=aux_number;

            }else if(number_decimal>0.50){
                cost_enrollment=number_enter+1;
                
            }else{                
                cost_enrollment=number_enter;
            }

            
            // let cost_enrollment = 3*this.c_type_propulsion;
            this.c_ship_approved_pending.importe_tramite=cost_enrollment;
            // return propulsion;
        },
        c_cal_cut(){
            let fact_a=0.1;
            let fact_b=2;
            let fact_c=1.8;
            let cut=fact_c/(1+fact_a*Math.pow(this.c_ship_approved_pending.trb, (1/fact_b) ))/2.3;
            return cut;
        },
        cQuestionEngine(){
            return this.d_question_engine;
        }
    },
    watch:{
        query_owner(newOwner) {
            // axios.get(`searchOwner/${newOwner}`)
            axios.get(`searchOwner/${newOwner}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    this.owners_enrollment = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-report':modalReport
    },
    filters:{
        round:function(value){
            let v_local=parseFloat(value)
            return v_local.toFixed(2);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/matriculacion/AdminMatriculacion.vue